export const CLIENT_DIAGNOSTIC_EVENTS = [
  'startup_failed',
  'renderer_failed',
  'route_failed',
  'browser_error',
  'unhandled_rejection',
  'connection_lost',
  'connection_restored',
  'connection_unavailable',
  'api_unavailable',
  'api_restored',
] as const;

export interface DiagnosticError {
  type: 'Error' | 'TypeError' | 'RangeError' | 'SyntaxError' | 'ReferenceError' | 'AggregateError' | 'Unknown';
  frames: string[];
}

export interface ClientDiagnostic {
  event: (typeof CLIENT_DIAGNOSTIC_EVENTS)[number];
  reportId: string;
  clientVersion: string;
  occurredAt: string;
  gameSessionId?: string;
  error?: DiagnosticError;
}

/** Only code locations survive; messages, causes and custom error fields can contain private state. */
export function summarizeDiagnosticError(error: unknown): DiagnosticError {
  if (!(error instanceof Error)) return { type: 'Unknown', frames: [] };
  const types: DiagnosticError['type'][] = [
    'Error',
    'TypeError',
    'RangeError',
    'SyntaxError',
    'ReferenceError',
    'AggregateError',
  ];
  const heading = `${error.name}: ${error.message}`;
  const stack = error.stack?.startsWith(heading) ? error.stack.slice(heading.length) : '';
  return {
    type: types.find((type) => type === error.name) ?? 'Error',
    frames: stack
      .split('\n')
      .filter((line) => /^\s+at /.test(line))
      .flatMap((line) => {
        const frame = /(?:[/\\( ])([a-zA-Z0-9_.-]{1,100}\.[cm]?[jt]sx?:\d{1,7}:\d{1,7})\)?$/.exec(line);
        return frame ? [frame[1]!] : [];
      })
      .slice(0, 6),
  };
}
